import { PublicClientApplication } from "@azure/msal-browser";

export const msalInstance = new PublicClientApplication({
  auth: {
    clientId: process.env.REACT_APP_USER_APP_CLIENT_ID,
    authority:
      "https://login.microsoftonline.com/704bef3c-134c-430e-860d-b9b9baa16039",
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
});
